import { module } from 'modujs';
import { lerp } from '../utils/utils';
import CursorChange from './cursor-change';
export default class extends module {
    constructor(m) {
        super(m);
        this.mouse = { x: -10, y: -10 };
        this.cursorPos = { x: 0, y: 0}


        document.addEventListener("mouseenter", (e) => {
            if( e.target.tagName === 'A' && ! e.target.dataset.moduleCursorChange ){
                this.add( 'hide' );
            }
        },true);
        document.addEventListener("mouseleave", (e) => {
            if( e.target.tagName === 'A' && ! e.target.dataset.moduleCursorChange ){
                this.remove( 'hide' );
            }
        },true);

    }

    init() {
        document.addEventListener( 'mousemove', this.mouseMove.bind( this ) );
        this.rafID = requestAnimationFrame( this.raf.bind( this ) );
    }

    mouseMove( e ){
        this.mouse = { x : e.clientX, y : e.clientY };
    }

    raf(){
        this.cursorPos = { x: lerp( this.cursorPos.x, this.mouse.x, 0.2 ), y: lerp( this.cursorPos.y, this.mouse.y, 0.2 ) };
        this.el.style.transform = `translate(${this.cursorPos.x}px, ${this.cursorPos.y}px)`;
        this.rafID = requestAnimationFrame( this.raf.bind( this ) );
    }

    toggle( c ){
        this.el.classList.toggle( c );
    }

    add( c ){
        this.el.classList.add( c );
    }

    remove( c ){
        this.el.classList.remove( c );
    }

    destroy(){}
}
